import React from "react";

/**
 * Standardisasi penulisan nama parasit (Plasmodium) agar bagian nama ilmiah
 * ditulis miring (italic) sesuai kaidah penulisan nama spesies.
 *
 * Hanya bagian nama ilmiah yang dimiringkan:
 * - Genus: "Plasmodium" dan singkatan genus "P."
 * - Epithet spesies: falciparum, falsiparum, vivax, ovale, malariae, knowlesi
 *
 * Kata non-spesies seperti "Probable", "mix", "terkonfirmasi", "Negatif",
 * "Malaria" tidak dimiringkan.
 */

// Satu grup penangkap membungkus seluruh alternasi agar delimiter ikut
// disertakan pada hasil String.prototype.split.
const PARASITE_REGEX =
  /(Plasmodium|\bP\.|\bfalciparum\b|\bfalsiparum\b|\bvivax\b|\bovale\b|\bmalariae\b|\bknowlesi\b)/gi;

const PARASITE_TOKEN_REGEX =
  /^(Plasmodium|P\.|falciparum|falsiparum|vivax|ovale|malariae|knowlesi)$/i;

const isParasiteToken = (token) => PARASITE_TOKEN_REGEX.test(token);

/**
 * Mengubah string nama parasit menjadi kumpulan node React dengan bagian
 * nama ilmiah dibungkus <i> (italic). Aman dipanggil pada teks apa pun:
 * jika tidak ada nama spesies, teks dikembalikan apa adanya.
 *
 * @param {string|number|null|undefined} text
 * @returns {React.ReactNode}
 */
export const formatParasite = (text) => {
  if (text === null || text === undefined) return text;

  // Multi-select array: gabungkan setiap elemen dengan koma + spasi
  if (Array.isArray(text)) {
    if (text.length === 0) return null;
    return text.map((item, index) => (
      <React.Fragment key={index}>
        {index > 0 ? ", " : null}
        {formatParasite(item)}
      </React.Fragment>
    ));
  }

  const str = String(text);
  const segments = str.split(PARASITE_REGEX);

  return segments.map((segment, index) => {
    if (!segment) return null;
    return isParasiteToken(segment) ? (
      <i key={index}>{segment}</i>
    ) : (
      <React.Fragment key={index}>{segment}</React.Fragment>
    );
  });
};

/**
 * Komponen pembungkus untuk menampilkan nama parasit dengan nama spesies
 * ditulis miring.
 *
 * Contoh: <ParasiteName text="Probable knowlesi" />
 */
const ParasiteName = ({ text, children }) => (
  <>{formatParasite(text ?? children)}</>
);

export default ParasiteName;
